import { api } from "@/lib/apiClient";
import {
  fetchSalesIndex,
  salesIndexErrorMessage,
  type SaleIndexRecord,
} from "@/lib/sales/salesIndexStore";
import type { SaleInvoiceRecord } from "@/lib/sales/saleInvoiceStore";

export type SaleReturnScope = "returnable" | "returned";

export type SaleReturnRecord = {
  id: number;
  sale_id: number;
  product_id?: number | null;
  customer_id?: number | null;
  return_date?: string | null;
  sale_amount: number;
  collected_amount: number;
  refunded_amount: number;
  retained_amount: number;
  notes?: string | null;
  created_by?: number | null;
  created_at?: string | null;
  refund_payments?: Array<{
    id: number;
    amount: number;
    payment_method?: string | null;
    payment_method_label?: string | null;
    bank_name?: string | null;
    transaction_reference_no?: string | null;
    pay_order_no?: string | null;
    payment_date?: string | null;
    notes?: string | null;
  }>;
};

const PER_PAGE = 100;

export async function syncSaleReturnsFromApi(scope: SaleReturnScope): Promise<SaleIndexRecord[]> {
  const collected: SaleIndexRecord[] = [];
  let page = 1;
  let lastPage = 1;
  do {
    const res = await fetchSalesIndex({ page, per_page: PER_PAGE, scope });
    collected.push(...(res.data ?? []));
    lastPage = res.meta?.last_page ?? 1;
    page += 1;
  } while (page <= lastPage && page <= 50);
  return collected;
}

export async function processSaleReturn(
  saleId: string | number,
  payload: {
    return_date?: string | null;
    notes?: string | null;
    retained_amount?: number | null;
    payment_method?: string | null;
    bank_id?: number | null;
    bank_name?: string | null;
    transaction_reference_no?: string | null;
    pay_order_no?: string | null;
    refunds?: Array<{
      amount: number;
      payment_method?: string | null;
      bank_id?: number | null;
      bank_name?: string | null;
      transaction_reference_no?: string | null;
      pay_order_no?: string | null;
      notes?: string | null;
    }>;
  } = {},
): Promise<{ message: string; record: SaleInvoiceRecord | null }> {
  const response = await api.post<{ message?: string; data?: SaleInvoiceRecord }>(
    `/api/v1/sales/${saleId}/return`,
    payload,
  );
  return {
    message: response.data?.message ?? "Sale returned.",
    record: response.data?.data ?? null,
  };
}

export { salesIndexErrorMessage };
export type { SaleIndexRecord };
